// eslint-disable-next-line import/no-anonymous-default-export
export default {
    UAH: 'UAH',
    RUB: 'RUB',
    USD: 'USD',
    EUR: 'EUR',
    GBP: 'GBP',
    TRY: 'TRY',
    KZT: 'KZT',
    AUD: 'AUD',
    BGN: 'BGN',
    BRL: 'BRL',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    COP: 'COP',
    CZK: 'CZK',
    DKK: 'DKK',
    DOP: 'DOP',
    EGP: 'EGP',
    HKD: 'HKD',
    HRK: 'HRK',
    IDR: 'IDR',
    ILS: 'ILS',
    JOD: 'JOD',
    JPY: 'JPY',
    KES: 'KES',
    KRW: 'KRW',
    KWD: 'KWD',
    LKR: 'LKR',
    MAD: 'MAD',
    MXN: 'MXN',
    MYR: 'MYR',
    NGN: 'NGN',
    NOK: 'NOK',
    NZD: 'NZD',
    OMR: 'OMR',
    PEN: 'PEN',
    PKR: 'PKR',
    PLN: 'PLN',
    RON: 'RON',
    SEK: 'SEK',
    SGD: 'SGD',
    THB: 'THB',
    TWD: 'TWD',
    VND: 'VND',
    ZAR: 'ZAR'
}